import { convertAmount } from './currencyConvert';

// Supplier cost of a booking expressed in the booking's CLIENT currency.
// BR OS sells and buys in different currencies (e.g. sold in EUR, bought in
// DKK/CZK/USD/PLN). supplier_total is in supplier_currency; bros_exchange_rate
// is BR OS's locked supplier->client rate, the same rate BR OS used for
// `margin` (client_total - supplier_total * rate). Reading supplier_total as
// if it were client currency inflated DKK costs ~7.5x (Fan, 2026-10-15).
export function supplierCostInClientCurrency(b, fxRates) {
  const amount = Number(b.supplier_total || 0);
  const clientCcy = b.currency || 'GBP';
  const supplierCcy = b.supplier_currency || clientCcy;
  if (!amount || supplierCcy === clientCcy) return amount;
  const rate = Number(b.bros_exchange_rate);
  if (rate > 0) return amount * rate;
  return convertAmount(amount, supplierCcy, clientCcy, fxRates) || 0;
}

// Invoice counterparty: client invoices carry `company`, supplier invoices
// carry `supplier_name` (company is null on them).
export function invoiceParty(inv) {
  return inv.company || inv.supplier_name || inv.client_name || '(unknown)';
}

// A cancelled booking that carries a cancellation fee (client invoices on
// it, ex VAT) is shown as a "Cancellation": its value is the fee, its cost
// is the supplier invoices on it, and it counts in the totals like any
// other booking (Fan, 2026-10-24: "show in Bookings as Cancellation").
// The API adds cancellation_fee_invoiced / cancellation_cost_invoiced in the
// booking currency (routes/bros.py); a booking without them is unchanged.
// Never key on BR OS's own `cancellation_fee`: every synced booking carries
// it as 0, which turned every row into a Cancellation (2026-10-24).
export function asCancellationRow(b) {
  if (!b || b.cancellation_fee_invoiced == null
      || String(b.status || '').toLowerCase() !== 'cancelled') return b;
  const fee = Number(b.cancellation_fee_invoiced || 0);
  const cost = Number(b.cancellation_cost_invoiced || 0);
  return {
    ...b,
    status: 'cancellation',
    booked_client_total: b.client_total,
    client_total: fee,
    supplier_total: cost,
    supplier_currency: b.currency,
    bros_exchange_rate: null,
    margin: fee - cost,
    num_nights: 0,
    revenue_excluded: false,
  };
}
